import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ContentTypes, MisContent, CustomContentService } from 'src/app/services/custom-content.service';

interface DialogData {
  contents: Array<any>;
  contentType: MisContent;
}

@Component({
  selector: 'mis-notifications',
  templateUrl: 'mis-notifications.component.html',
  styleUrls: ['mis-notifications.component.scss'],
})
export class MisNotificationsComponent implements OnInit {
  private currentLang: any;
  public currentMessage: any;
  public currentIndex: number;
  contentTypes: ContentTypes;

  constructor(
    public cService: CommonService,
    private cContentService: CustomContentService,
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData
  ) {
    this.contentTypes = this.cContentService.contentTypes;

    console.log('%cCURRENT CONTENT TYPE', 'color: lime', this.cContentService.currentContentType);
  }

  ngOnInit() {
    console.log('%cDIALOG DATA!', 'color: lime', this.dialogData);

    this.currentIndex = 0;
    this.getCurrentContent();
  }

  private getCurrentContent() {
    this.currentLang = this.dialogData.contents[this.currentIndex];

    this.currentMessage = this.currentLang[this.cService.userProfile.languageCode]
      ? this.currentLang[this.cService.userProfile.languageCode]
      : this.currentLang[this.cContentService.defaultLanguage.shortCode];
  }

  nextContent() {
    this.currentIndex = this.currentIndex === this.dialogData.contents.length - 1 ? 0 : this.currentIndex + 1;
    this.acknowledgeContent();
    this.getCurrentContent();
  }

  previousContent() {
    this.currentIndex = this.currentIndex === 0 ? this.dialogData.contents.length - 1 : this.currentIndex - 1;
    this.acknowledgeContent();
    this.getCurrentContent();
  }

  continueToNextContent() {
    this.currentIndex < this.dialogData.contents.length - 1 ? this.nextContent() : this.closeDialog();
  }

  private closeDialog() {
    this.cContentService.dialog.closeAll();
    this.acknowledgeContent();
  }

  private acknowledgeContent() {
    if (this.cContentService.acknowledgeableContent.includes(this.dialogData.contentType)) {
      this.cContentService.acknowledgeNotification(this.currentMessage.messageID);
    }
  }
}
